/* eslint-disable no-console */
import useJSONStore from '../store/StaticJson/jsonStore';

export const defaultCountry = '101';

const FilteredUnit = (selectedCountry: string): any => {
  const unitPreference = useJSONStore.getState().unitPreference;

  return unitPreference[Number(selectedCountry)] ?? unitPreference[0];
};

export default FilteredUnit;
